import React, { ReactElement } from 'react'

import * as Styled from './styles'

export const NavListLoading = (): ReactElement => (
  <Styled.NavListLoadingWrapper>
    <Styled.RotatingIcon icon="circleDashed" />
  </Styled.NavListLoadingWrapper>
)
